'use client'
import * as React from 'react'

import * as DashboardHeader from '~/sotano-kit/primitives/dashboard-header'
import {
  PublicRepo,
  PublicTeam,
} from '@basehub/data/replicache/mutators/_public-types'
import { TeamDropdownMenu } from '../../[team-slug]/header/team-dropdown-menu'
import { useUserStore } from '~/app/_store/user-store'
import { Badge } from '~/components/badge'
import { useFlags } from '~/lib/flags/provider'
import { useIsGuest } from '~/hooks-data/use-user-role'

export const PublicDashHeader = ({
  team,
  repo,
  versionBadge,
}: {
  team: PublicTeam
  repo: PublicRepo | null
  versionBadge: React.ReactNode
}) => {
  const isLoggedIn = useUserStore((s) => Boolean(s.optimisticUser?.id))
  const branching = useFlags().branching
  const isGuest = useIsGuest()

  return (
    <DashboardHeader.Root>
      <DashboardHeader.LeftSide>
        <DashboardHeader.Logo logoHref={`/${team.slug}`}>
          {versionBadge}
        </DashboardHeader.Logo>
        <DashboardHeader.BreadCrumbs
          breadcrumbs={[
            ...(team
              ? [
                  {
                    title: team.title,
                    isActive: !repo?.slug && !repo?.title,
                    href: `/${team.slug}`,
                    menu: isLoggedIn && <TeamDropdownMenu />,
                    badge: isGuest && <Badge intent="secondary">Guest</Badge>,
                  },
                  ...(repo?.title
                    ? [
                        {
                          title: repo.title,
                          isActive: true,
                          href: `/${team.slug}/${repo.slug}/explore`,
                          menu: branching ? (
                            <span id="branch-switcher-portal" />
                          ) : null,
                        },
                      ]
                    : []),
                ]
              : []),
          ]}
        />
      </DashboardHeader.LeftSide>

      <DashboardHeader.UserNav />
    </DashboardHeader.Root>
  )
}
